import { Injectable, NgZone } from '@angular/core';
import { User } from "../services/user";
import * as firebase  from 'firebase/app';
import 'firebase/auth';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { Observable, Subscription } from 'rxjs';
// import { newUser } from '../model/newUser';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userData: User; // Save logged in user data
  user: Observable<User>;
  private roleSubscription: Subscription;

  constructor(
    public afs: AngularFirestore,   // Inject Firestore szervice
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,  
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {    
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        localStorage.setItem('useremail', this.userData.email);
        JSON.parse(localStorage.getItem('user'));
        // fetch user role from users collection and cache in localStorage
        try {
          this.roleSubscription?.unsubscribe();
          this.roleSubscription = this.afs.doc<any>(`users/${this.userData.email}`).valueChanges()
            .subscribe(doc => {
              const role = doc && doc.role ? doc.role : 'learner';
              localStorage.setItem('userrole', role);
            });
        } catch (e) {
          console.warn('Failed to fetch user role', e);
          localStorage.setItem('userrole', 'learner');
        }
      } else {
        localStorage.setItem('user', null);
        localStorage.setItem('useremail', null);
        JSON.parse(localStorage.getItem('user'));
        localStorage.setItem('userrole', null);
      }
    })
  }

  // Sign in with email/password
  SignIn(email: string, password: string) {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then(async(result) => {
         // if email not verified, send verification and sign out
        if (!result.user?.emailVerified) {
          await (await this.afAuth.currentUser).sendEmailVerification();
          await this.afAuth.signOut();
          window.alert('Please verify your email. A verification link has been sent.');
          throw new Error('Email not verified');
        }
        
        window.alert('Hi, you have successfully logged in.');
        // const user = result.user;
        // if (!user) throw new Error('User not found');
        // persist signin info
        this.SigninData(result.user);
        // Get user role from Firestore
        const userDoc = await this.afs
        .doc(`users/${email}`)
        .get()
        .toPromise();

      const role = userDoc?.data()?.role;
        // navigate once inside Angular zone
        this.ngZone.run(() => {
          if (role === 'admin') {
          this.router.navigate(['admin/fea-applications']);
        } else {
          this.router.navigate(['dashboard']);
        }
        });
        return result;
      }).catch((error) => {
        window.alert(error.message);
        throw error;
      });
  }

  // Sign up with email/password
  SignUp(email, password) {
    return this.afAuth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        console.log(result)
        this.SendVerificationMail();
        // this.SetUserData(result.user);
        window.location.reload();
      }).catch((error) => {
        // window.alert(error.message)
        console.log(error.message); //what is wrong with the signup popup error
      })
  }

  // Send email verfificaiton when new user sign up
 async SendVerificationMail() {
    return (await this.afAuth.currentUser).sendEmailVerification()
    .then(() => {
      this.router.navigate(['verify-email-address']);
    })
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
    .then(() => {
      window.alert('Password reset email sent, check your inbox.');
    }).catch((error) => {
      window.alert(error)
    })
  }

  // Returns true when user is logged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null && user.emailVerified !== false) ? true : false;
  }

  // Returns true when there is a user object persisted (regardless of email verification)
  get hasUser(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return user !== null;
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new firebase.auth.GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.afAuth.signInWithPopup(provider)
    .then((result) => {
       this.ngZone.run(() => {
          this.router.navigate(['dashboard']);
        })
      this.SetUserData(result.user);
    }).catch((error) => {
      window.alert(error)
    })
  }

  /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
  SetUserData(webUser) {

    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${webUser.userEmail}`);
  //  const userRef: AngularFirestoreDocument<any> = doc(this.afs, "users", webUser.userEmail);
    const userData = {
      createdAt: new Date(),
      uid: webUser.uid,
      email: webUser.userEmail,
      displayName: webUser.userName,
      photoURL: webUser.photoURL,
      phoneNumber: webUser.phoneNumber,
      emailVerified: webUser.emailVerified,
      role: 'learner' // default role
    }
    return userRef.set(userData, {
      merge: true
    })
  }

  SigninData(user) {

    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.email}`);
    const signinData = {
      uid: user.uid,
      // email: user.email,
      emailVerified: user.emailVerified
    }
    return userRef.set(signinData, {
      merge: true
    })
  }

  // Sign out 
  SignOut() {
    return this.afAuth.signOut().then(() => {
      localStorage.removeItem('user');
      localStorage.removeItem('useremail');
      localStorage.removeItem('userrole');
      this.roleSubscription?.unsubscribe();
      this.router.navigate(['home']);
    })
  }

  // Role helpers
  getUserRole(): string | null {
    return localStorage.getItem('userrole');
  }

  isAdmin(): boolean {
    return this.getUserRole() === 'admin';
  }

  isLearner(): boolean {
    return this.getUserRole() === 'learner';
  }

}
